/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { CountTrackers200Response } from '../models';
// @ts-ignore
import type { CreateTracker200Response } from '../models';
// @ts-ignore
import type { DeleteTracker200Response } from '../models';
// @ts-ignore
import type { GetTrackerById200Response } from '../models';
// @ts-ignore
import type { ListTrackers200Response } from '../models';
// @ts-ignore
import type { ReactivateTrackerWebhook200Response } from '../models';
// @ts-ignore
import type { SearchGroupsAdmin200Response } from '../models';
// @ts-ignore
import type { SortOrder } from '../models';
// @ts-ignore
import type { TrackerCreateDTO } from '../models';
// @ts-ignore
import type { TrackerUpdateDTO } from '../models';
/**
 * TrackerApi - axios parameter creator
 */
export const TrackerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary countTrackers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTrackers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/tracker/count/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary createTracker
         * @param {TrackerCreateDTO} trackerCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTracker: async (trackerCreateDTO: TrackerCreateDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackerCreateDTO' is not null or undefined
            assertParamExists('createTracker', 'trackerCreateDTO', trackerCreateDTO)
            const localVarPath = `/api/nora/tracker`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trackerCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteTracker
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTracker: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTracker', 'id', id)
            const localVarPath = `/api/nora/tracker/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getTrackerById
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackerById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTrackerById', 'id', id)
            const localVarPath = `/api/nora/tracker/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getWebhookStatusById
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookStatusById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWebhookStatusById', 'id', id)
            const localVarPath = `/api/nora/tracker/{id}/status`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary trackSubscriptionWebhook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrackers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/tracker`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary reactivateTrackerWebhook
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateTrackerWebhook: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reactivateTrackerWebhook', 'id', id)
            const localVarPath = `/api/nora/tracker/{id}/reactivate-webhook`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary searchTrackers
         * @param {string} [query] 
         * @param {string} [filter] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {SortOrder} [sortOrder] 
         * @param {string} [cursor] 
         * @param {string} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTrackers: async (query?: string, filter?: string, skip?: number, limit?: number, sortOrder?: SortOrder, cursor?: string, sortBy?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/tracker/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary sendTestDataToWebhook
         * @param {string} id 
         * @param {string} body Raw webhook payload in JSON, XML, or plain text format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTestDataToWebhook: async (id: string, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sendTestDataToWebhook', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('sendTestDataToWebhook', 'body', body)
            const localVarPath = `/api/nora/tracker/{id}/test`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateTracker
         * @param {string} id 
         * @param {TrackerUpdateDTO} trackerUpdateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTracker: async (id: string, trackerUpdateDTO: TrackerUpdateDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTracker', 'id', id)
            // verify required parameter 'trackerUpdateDTO' is not null or undefined
            assertParamExists('updateTracker', 'trackerUpdateDTO', trackerUpdateDTO)
            const localVarPath = `/api/nora/tracker/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trackerUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrackerApi - functional programming interface
 */
export const TrackerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrackerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary countTrackers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countTrackers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountTrackers200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countTrackers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackerApi.countTrackers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary createTracker
         * @param {TrackerCreateDTO} trackerCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTracker(trackerCreateDTO: TrackerCreateDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateTracker200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTracker(trackerCreateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackerApi.createTracker']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary deleteTracker
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTracker(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteTracker200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTracker(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackerApi.deleteTracker']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getTrackerById
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrackerById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTrackerById200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrackerById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackerApi.getTrackerById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getWebhookStatusById
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebhookStatusById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReactivateTrackerWebhook200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebhookStatusById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackerApi.getWebhookStatusById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary trackSubscriptionWebhook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTrackers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrackers200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTrackers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackerApi.listTrackers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary reactivateTrackerWebhook
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reactivateTrackerWebhook(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReactivateTrackerWebhook200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reactivateTrackerWebhook(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackerApi.reactivateTrackerWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary searchTrackers
         * @param {string} [query] 
         * @param {string} [filter] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {SortOrder} [sortOrder] 
         * @param {string} [cursor] 
         * @param {string} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchTrackers(query?: string, filter?: string, skip?: number, limit?: number, sortOrder?: SortOrder, cursor?: string, sortBy?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchGroupsAdmin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchTrackers(query, filter, skip, limit, sortOrder, cursor, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackerApi.searchTrackers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary sendTestDataToWebhook
         * @param {string} id 
         * @param {string} body Raw webhook payload in JSON, XML, or plain text format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendTestDataToWebhook(id: string, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendTestDataToWebhook(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackerApi.sendTestDataToWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary updateTracker
         * @param {string} id 
         * @param {TrackerUpdateDTO} trackerUpdateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTracker(id: string, trackerUpdateDTO: TrackerUpdateDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateTracker200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTracker(id, trackerUpdateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackerApi.updateTracker']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TrackerApi - factory interface
 */
export const TrackerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrackerApiFp(configuration)
    return {
        /**
         * 
         * @summary countTrackers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTrackers(options?: RawAxiosRequestConfig): AxiosPromise<CountTrackers200Response> {
            return localVarFp.countTrackers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary createTracker
         * @param {TrackerApiCreateTrackerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTracker(requestParameters: TrackerApiCreateTrackerRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateTracker200Response> {
            return localVarFp.createTracker(requestParameters.trackerCreateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteTracker
         * @param {TrackerApiDeleteTrackerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTracker(requestParameters: TrackerApiDeleteTrackerRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteTracker200Response> {
            return localVarFp.deleteTracker(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getTrackerById
         * @param {TrackerApiGetTrackerByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrackerById(requestParameters: TrackerApiGetTrackerByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetTrackerById200Response> {
            return localVarFp.getTrackerById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getWebhookStatusById
         * @param {TrackerApiGetWebhookStatusByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookStatusById(requestParameters: TrackerApiGetWebhookStatusByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReactivateTrackerWebhook200Response> {
            return localVarFp.getWebhookStatusById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary trackSubscriptionWebhook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTrackers(options?: RawAxiosRequestConfig): AxiosPromise<ListTrackers200Response> {
            return localVarFp.listTrackers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary reactivateTrackerWebhook
         * @param {TrackerApiReactivateTrackerWebhookRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateTrackerWebhook(requestParameters: TrackerApiReactivateTrackerWebhookRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReactivateTrackerWebhook200Response> {
            return localVarFp.reactivateTrackerWebhook(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary searchTrackers
         * @param {TrackerApiSearchTrackersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTrackers(requestParameters: TrackerApiSearchTrackersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SearchGroupsAdmin200Response> {
            return localVarFp.searchTrackers(requestParameters.query, requestParameters.filter, requestParameters.skip, requestParameters.limit, requestParameters.sortOrder, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary sendTestDataToWebhook
         * @param {TrackerApiSendTestDataToWebhookRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTestDataToWebhook(requestParameters: TrackerApiSendTestDataToWebhookRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.sendTestDataToWebhook(requestParameters.id, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateTracker
         * @param {TrackerApiUpdateTrackerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTracker(requestParameters: TrackerApiUpdateTrackerRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateTracker200Response> {
            return localVarFp.updateTracker(requestParameters.id, requestParameters.trackerUpdateDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createTracker operation in TrackerApi.
 */
export interface TrackerApiCreateTrackerRequest {
    readonly trackerCreateDTO: TrackerCreateDTO
}

/**
 * Request parameters for deleteTracker operation in TrackerApi.
 */
export interface TrackerApiDeleteTrackerRequest {
    readonly id: string
}

/**
 * Request parameters for getTrackerById operation in TrackerApi.
 */
export interface TrackerApiGetTrackerByIdRequest {
    readonly id: string
}

/**
 * Request parameters for getWebhookStatusById operation in TrackerApi.
 */
export interface TrackerApiGetWebhookStatusByIdRequest {
    readonly id: string
}

/**
 * Request parameters for reactivateTrackerWebhook operation in TrackerApi.
 */
export interface TrackerApiReactivateTrackerWebhookRequest {
    readonly id: string
}

/**
 * Request parameters for searchTrackers operation in TrackerApi.
 */
export interface TrackerApiSearchTrackersRequest {
    readonly query?: string

    readonly filter?: string

    readonly skip?: number

    readonly limit?: number

    readonly sortOrder?: SortOrder

    readonly cursor?: string

    readonly sortBy?: string
}

/**
 * Request parameters for sendTestDataToWebhook operation in TrackerApi.
 */
export interface TrackerApiSendTestDataToWebhookRequest {
    readonly id: string

    /**
     * Raw webhook payload in JSON, XML, or plain text format
     */
    readonly body: string
}

/**
 * Request parameters for updateTracker operation in TrackerApi.
 */
export interface TrackerApiUpdateTrackerRequest {
    readonly id: string

    readonly trackerUpdateDTO: TrackerUpdateDTO
}

/**
 * TrackerApi - object-oriented interface
 */
export class TrackerApi extends BaseAPI {
    /**
     * 
     * @summary countTrackers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public countTrackers(options?: RawAxiosRequestConfig) {
        return TrackerApiFp(this.configuration).countTrackers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary createTracker
     * @param {TrackerApiCreateTrackerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createTracker(requestParameters: TrackerApiCreateTrackerRequest, options?: RawAxiosRequestConfig) {
        return TrackerApiFp(this.configuration).createTracker(requestParameters.trackerCreateDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteTracker
     * @param {TrackerApiDeleteTrackerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteTracker(requestParameters: TrackerApiDeleteTrackerRequest, options?: RawAxiosRequestConfig) {
        return TrackerApiFp(this.configuration).deleteTracker(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getTrackerById
     * @param {TrackerApiGetTrackerByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTrackerById(requestParameters: TrackerApiGetTrackerByIdRequest, options?: RawAxiosRequestConfig) {
        return TrackerApiFp(this.configuration).getTrackerById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getWebhookStatusById
     * @param {TrackerApiGetWebhookStatusByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getWebhookStatusById(requestParameters: TrackerApiGetWebhookStatusByIdRequest, options?: RawAxiosRequestConfig) {
        return TrackerApiFp(this.configuration).getWebhookStatusById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary trackSubscriptionWebhook
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listTrackers(options?: RawAxiosRequestConfig) {
        return TrackerApiFp(this.configuration).listTrackers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary reactivateTrackerWebhook
     * @param {TrackerApiReactivateTrackerWebhookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reactivateTrackerWebhook(requestParameters: TrackerApiReactivateTrackerWebhookRequest, options?: RawAxiosRequestConfig) {
        return TrackerApiFp(this.configuration).reactivateTrackerWebhook(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary searchTrackers
     * @param {TrackerApiSearchTrackersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchTrackers(requestParameters: TrackerApiSearchTrackersRequest = {}, options?: RawAxiosRequestConfig) {
        return TrackerApiFp(this.configuration).searchTrackers(requestParameters.query, requestParameters.filter, requestParameters.skip, requestParameters.limit, requestParameters.sortOrder, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary sendTestDataToWebhook
     * @param {TrackerApiSendTestDataToWebhookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendTestDataToWebhook(requestParameters: TrackerApiSendTestDataToWebhookRequest, options?: RawAxiosRequestConfig) {
        return TrackerApiFp(this.configuration).sendTestDataToWebhook(requestParameters.id, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateTracker
     * @param {TrackerApiUpdateTrackerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateTracker(requestParameters: TrackerApiUpdateTrackerRequest, options?: RawAxiosRequestConfig) {
        return TrackerApiFp(this.configuration).updateTracker(requestParameters.id, requestParameters.trackerUpdateDTO, options).then((request) => request(this.axios, this.basePath));
    }
}

